import ErrorPage from '@/components/ErrorPage';

export default function Error404() {
  return (
    <ErrorPage
      errorCode="404"
      title="Oops! This Page Melted Away"
      message="Just like ice cream on a hot day, the page you're looking for has disappeared. It might have been moved, deleted, or perhaps it never existed."
      imagePath="/error-404.png"
      showRefresh={false}
    />
  );
}